module.exports = __webpack_public_path__ + "static/media/7db1f672-3a8f-4d19-9c49-7f61aed450b5.bac188b4.woff2";